// Angular
import { Component, inject } from "@angular/core";
import { Params, Router } from "@angular/router";

// Models
import {
    NavigationLayoutItem,
    NavigationLayoutItemsList,
    NavigationLayoutList,
} from "#models/navigation";

// Services
import { UserService } from "#services/user/user.service";

// Data
import { getNavigationList } from "#components/navigation-base/navigation-base.component.data";

@Component({
    selector: "app-navigation-base",
    imports: [],
    template: "",
})
export class NavigationBaseComponent {
    list!: NavigationLayoutList;
    queryParamsMap = new Map();

    private userService = inject(UserService);
    protected router = inject(Router);

    constructor() {
        this.list = getNavigationList().filter(
            (navigationItem: NavigationLayoutItemsList | NavigationLayoutItem) => {
                if (navigationItem.submenu) {
                    navigationItem.children = navigationItem.children.filter((child) =>
                        child.can ? this.userService.can(child.can) : true
                    );

                    return navigationItem.children.length;
                }

                if (navigationItem.can) {
                    return this.userService.can(navigationItem.can);
                }

                return true;
            }
        );
    }

    getQueryParamsForLink(item: NavigationLayoutItem) {
        const queryParams = item.queryParams;

        return item.withCurrentQuery ? this.mergeQueryParams(queryParams) : queryParams;
    }

    protected getQueryParams() {
        if (this.queryParamsMap.has(this.router.url)) {
            return this.queryParamsMap.get(this.router.url);
        }

        const queryParams = this.router.parseUrl(this.router.url).queryParams;
        this.queryParamsMap.set(this.router.url, queryParams);

        return queryParams;
    }

    protected mergeQueryParams(params: Params | undefined) {
        if (params) {
            const newQueries = {
                ...this.getQueryParams(),
                ...params,
            };

            Object.entries(newQueries).forEach(([key, value]) => {
                if (value === null) {
                    delete newQueries[key];
                }
            });

            return newQueries;
        }

        return undefined;
    }
}
